<div class="main-content-text">
  <div class="top-row">
    <button class="back-btn" (click)="goBack()" title="Go back">
      <i class="fa-solid fa-arrow-left fa"></i> {{ backButtonText }}
    </button>
    <div class="badges">
      <div *ngIf="isOneTimeView" class="one-time-badge">
        <div class="badge-dot"></div>
        One-time view
      </div>
      <div *ngIf="hasPin" class="pin-badge">
        <div class="badge-dot"></div>
        PIN Protected
      </div>
      <div *ngIf="isIpRestricted" class="ip-badge">
        <div class="badge-dot"></div>
        Same Network
      </div>
      <div
        *ngIf="isCreator && (expiryInMinutes || expiryTime)"
        class="expiry-badge"
      >
        <div class="badge-dot"></div>
        {{ getExpiryText() }}
      </div>
      <div
        *ngIf="isCreator && !expiryInMinutes && !expiryTime"
        class="expiry-badge"
      >
        <div class="badge-dot"></div>
        No Expiry
      </div>
      <div *ngIf="!isCreator && !expiryTime" class="expiry-badge">
        <div class="badge-dot"></div>
        No Expiry
      </div>
      <div *ngIf="!isCreator && expiryTime">
        <app-countdown
          [expiryTime]="expiryTime"
          [isCreator]="isCreator"
          (expired)="onExpired()"
        ></app-countdown>
      </div>
    </div>
  </div>

  <div class="textarea-flex-wrapper" [class.expired]="isExpired">
    <textarea rows="8" readonly>{{ isExpired ? '' : text }}</textarea>
    <button
      *ngIf="!isExpired"
      class="copy-text-btn"
      (click)="copyText()"
      [class.copied]="textCopied"
      title="Copy text"
    >
      <span *ngIf="!textCopied"><i class="fa-solid fa fa-copy"></i></span>
      <span *ngIf="textCopied"
        ><i class="fa-solid fa fa-clipboard-check"></i
      ></span>
    </button>
  </div>
  <app-share-card [url]="currentUrl"></app-share-card>

  <app-share-card-options
    [isOneTimeView]="isOneTimeView"
    [hasPin]="hasPin"
    [isCreator]="isCreator"
    [showDeleteOption]="true"
    [showWarnings]="!!text"
    [currentUrl]="currentUrl"
    (onDelete)="confirmDelete()"
  ></app-share-card-options>
</div>

<app-pin-modal
  [showPinModal]="showPinModal"
  [pinError]="pinError"
  (close)="onPinModalClose()"
  (submit)="onPinSubmit($event)"
></app-pin-modal>

<!-- Expired Overlay -->
<div *ngIf="isExpired" class="expired-overlay">
  <svg
    width="56"
    height="56"
    fill="none"
    stroke="#f75f5f"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="8" x2="12" y2="12"></line>
    <line x1="12" y1="16" x2="12.01" y2="16"></line>
  </svg>
  <h2>Link Expired</h2>
  <p>
    This link has expired. The text has been permanently deleted and cannot be
    accessed again.
  </p>
  <button class="back-btn" (click)="goBack()">Go back</button>
</div>
